import React from 'react';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <ModuleRoute moduleName="axp-page-wrapper" containerClassName="form-wrapper" key="wrapper">
    <ModuleRoute exact={true} path="/iForms/:pageType/:cuid" moduleName="axp-iform-renderer" />
  </ModuleRoute>,
];

export default childRoutes;
